import React from 'react';

// MUI Icons
import AreaChartIcon from '@mui/icons-material/AreaChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataObjectIcon from '@mui/icons-material/DataObject';
import EditIcon from '@mui/icons-material/Edit';
import ExploreIcon from '@mui/icons-material/Explore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FunctionsIcon from '@mui/icons-material/Functions';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import HomeIcon from '@mui/icons-material/Home';
import ImageIcon from '@mui/icons-material/Image';
import MovingIcon from '@mui/icons-material/Moving';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import NotesIcon from '@mui/icons-material/Notes';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import RouteIcon from '@mui/icons-material/Route';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SpeedIcon from '@mui/icons-material/Speed';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import WorkIcon from '@mui/icons-material/Work';
import SettingsIcon from '@mui/icons-material/Settings';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AbcIcon from '@mui/icons-material/Abc';
import BackpackIcon from '@mui/icons-material/Backpack';
import PaletteIcon from '@mui/icons-material/Palette';

// Your custom icons (Lucide or similar)
import { ArrowDownToLine, ArrowUpToLine, CircleSlash2, Radius, TabletSmartphone } from 'lucide-react';

const styleHeading = { marginRight: '0.6rem', fontSize: '1.6rem' };
const styleContent = { marginRight: '0.75rem', fontSize: '1.4rem' };
const styleInline = { marginRight: '0.5rem', fontSize: '1.25rem' };
const stylePopup = styleInline;
const styleMarker = { fontSize: '1.25rem' };

const Icons = {
  drawer: {
    heading: {
      filters:     <FilterAltIcon style={styleHeading} />,
      statistics:  <BarChartIcon style={styleHeading} />,
      charts:      <AreaChartIcon style={styleHeading} />,
      user:        <PersonIcon style={styleHeading} />,
      preferences: <SettingsIcon style={styleHeading} />,
      import:      <CloudUploadIcon style={styleHeading} />,
      editing:     <EditIcon style={styleHeading} />,
    },
    content: {
      altitude:     <NorthEastIcon style={styleContent} />,
      bearing:      <ExploreIcon style={styleContent} />,
      speed:        <SpeedIcon style={styleContent} />,
      velocity:     <SpeedIcon style={styleContent} />,
      acceleration: <SpeedIcon style={styleContent} />,
      provider:     <SatelliteAltIcon style={styleContent} />,
      totals:       <FunctionsIcon style={styleContent} />,
      smoothing:    <ScatterPlotIcon style={styleContent} />,
      colors:       <PaletteIcon style={styleContent} />,
      paths:        <RouteIcon style={styleContent} />,
      markers:      <PlaceIcon style={styleContent} />,
      datetime:     <CalendarMonthIcon style={styleContent} />,
      value:        <AbcIcon style={styleContent} />,
      accuracy:     <Radius size="1.4rem" style={styleContent} />,
      source:       <TabletSmartphone size="1.4rem" style={styleContent} />,
      travel_mode:  <BackpackIcon style={styleContent} />,
    },
    inline: {
      points:   <ScatterPlotIcon style={styleInline} />,
      distance: <RouteIcon style={styleInline} />,
      duration: <TimelapseIcon style={styleInline} />,
      minimum:  <ArrowDownToLine size="1.25rem" style={styleInline} />,
      maximum:  <ArrowUpToLine size="1.25rem" style={styleInline} />,
      average:  <CircleSlash2 size="1.1rem" style={styleInline} />,
    }
  },
  popup: {
    heading: {
      point: <PlaceIcon style={stylePopup} />,
    },
    content: {
      user:            <PersonIcon style={stylePopup} />,
      track:           <MovingIcon style={stylePopup} />,
      time:            <ScheduleIcon style={stylePopup} />,
      date:            <CalendarMonthIcon style={stylePopup} />,
      latitude:        <GpsFixedIcon style={stylePopup} />,
      longitude:       <GpsFixedIcon style={stylePopup} />,
      altitude:        <NorthEastIcon style={stylePopup} />,
      speed:           <SpeedIcon style={stylePopup} />,
      bearing:         <ExploreIcon style={stylePopup} />,
      provider:        <SatelliteAltIcon style={stylePopup} />,
      comment:         <NotesIcon style={stylePopup} />,
      image:           <ImageIcon style={stylePopup} />,
      additional_data: <DataObjectIcon style={stylePopup} />,
      duration:        <TimelapseIcon style={stylePopup} />,
      distance:        <RouteIcon style={stylePopup} />,
      accuracy:        <Radius size="1.25rem" style={stylePopup} />,
      source:          <TabletSmartphone size="1.25rem" style={stylePopup} />,
      travel_mode:     <BackpackIcon style={stylePopup} />,
    }
  },
  pois: {
    inline: {
      home:  <HomeIcon style={styleMarker} />,
      work:  <WorkIcon style={styleMarker} />,
      place: <PlaceIcon style={styleMarker} />,
      city:  <LocationCityIcon style={styleMarker} />,
    }
  }
};

export default Icons;
